import _ from 'lodash';
import * as types from '../types';

const getPricingModule = {
    state: {
        showPhone: true,
        showEmail: false,
    },

    mutations: {
        [types.GET_PRICING__MUTATE_STATE](localState, payload) {
            if (localState.showPhone !== payload.showPhone && !_.isUndefined(payload.showPhone)) {
                // eslint-disable-next-line no-param-reassign
                localState.showPhone = payload.showPhone;
            }
            if (localState.showEmail !== payload.showEmail && !_.isUndefined(payload.showEmail)) {
                // eslint-disable-next-line no-param-reassign
                localState.showEmail = payload.showEmail;
            }
        },
    },

    actions: {
        [types.GET_PRICING__UPDATE_STATE]({ commit }, { showPhone, showEmail }) {
            commit(types.GET_PRICING__MUTATE_STATE, { showPhone, showEmail });
        },
    },
};

export default getPricingModule;
